export const paginacion = (paginaActual, listaObjetos, objetosPorPagina) => {
  const paginas = []
  if (listaObjetos?.length === 0) {
    return {
      paginas: [],
      objetosEnPagina: []
    }
  }
  const OBJETOS_POR_PAGINA = objetosPorPagina
  const totalPages = Math.ceil(listaObjetos?.length / OBJETOS_POR_PAGINA)
  const sliceEnd = (OBJETOS_POR_PAGINA * paginaActual)
  const sliceStart = sliceEnd - OBJETOS_POR_PAGINA
  const objetosEnPagina = listaObjetos?.slice(sliceStart, sliceEnd)
  for (let i = 1; i <= totalPages; i++) {
    paginas.push(i)
  }
  const maxButtons = 5
  const paginaInicial = Math.max(1, paginaActual - Math.floor(maxButtons / 2))
  const paginaFinal = Math.min(paginas.length, paginaInicial + maxButtons - 1)
  return {
    objetosEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  }
}